<ng-progress #progressBar [spinner]="false" [color]="'#9327fe'"></ng-progress>
<router-outlet></router-outlet>
